import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
} from "@mui/material";

import { Link } from "react-router-dom";

import {
  useDeleteWebsiteContactMutation,
  useGetWebsiteContactsQuery,
  useUpdateWebsiteContactMutation,
} from "../../../features/api/websiteApi";
import { useState } from "react";

const ContactUs = () => {
  const { data: messages, error, isLoading } = useGetWebsiteContactsQuery();
  const [updateWebsiteContact] = useUpdateWebsiteContactMutation();
  const [deleteWebsiteContact] = useDeleteWebsiteContactMutation();

  const [searchTerm, setSearchTerm] = useState("");

  const filterSearch = searchTerm
    ? messages?.filter(
        (d) =>
          d?.name?.toLowerCase()?.includes(searchTerm?.toLocaleLowerCase()) ||
          d?.mobile?.includes(searchTerm) ||
          d?.email?.toLowerCase()?.includes(searchTerm?.toLocaleLowerCase())
      )
    : messages;

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  if (isLoading) return <p>Loading...</p>;
  if (error) return <p>Something went wrong!</p>;

  return (
    <div>
      <div className="flex justify-between items-center px-12 my-6">
        <h1 className="text-xl font-bold">Message From Website</h1>
        <div className="flex items-center gap-2">
          {/* <Link
            to="/dashboard/product-service/create"
            className="text-white bg-blue-600 uppercase cursor-pointer flex items-center gap-1 px-2 py-1 rounded"
          >
            <span>
              <MdAdd className="text-xl" />
            </span>
            <span>New Entry</span>
          </Link> */}
        </div>
      </div>
      <input
        type="text"
        placeholder="Search"
        className="border ml-12 focus:outline-none h-8 rounded p-1"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      <div className="h-[71vh] overflow-auto w-full m-auto px-12 my-5">
        {isLoading ? (
          <div className="w-fll h-screen flex flex-col items-center justify-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900"></div>
          </div>
        ) : filterSearch?.length === 0 ? (
          <p className=" text-xl text-red-500 mt-20 ml-20">
            There are no message from the website
          </p>
        ) : (
          <TableContainer component={Paper} className="border">
            <Table stickyHeader>
              <TableHead className="bg-blue-500">
                <TableRow>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">#</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Name</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Phone</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Email</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold">Subject</span>
                  </TableCell>
                  <TableCell style={{ backgroundColor: "#f0f0f5" }}>
                    <span className="font-bold ">Action</span>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filterSearch
                  ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  ?.map((row, i) => {
                    return (
                      <TableRow key={i}>
                        <TableCell>{i + 1}</TableCell>
                        <TableCell>{row?.name}</TableCell>
                        <TableCell>{row?.mobile}</TableCell>
                        <TableCell>{row?.email}</TableCell>
                        <TableCell>{row?.subj}</TableCell>
                        <TableCell className="">
                          <div className="flex items-center gap-x-4">
                            <Link
                              to="/dashboard/website/contact-message"
                              state={row}
                            >
                              <span className="border border-blue-600 p-1 rounded text-blue-600">
                                View
                              </span>
                            </Link>
                          </div>
                        </TableCell>
                      </TableRow>
                    );
                  })}
              </TableBody>
            </Table>
            <TablePagination
              style={{ backgroundColor: "#f0f0f5" }}
              rowsPerPageOptions={[50, 100, 200]}
              component="div"
              count={filterSearch?.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </TableContainer>
        )}
      </div>
    </div>
  );
};

export default ContactUs;
